// import ApiService from '@/common/api.service.js'
import CompanyService from '@/common/company.service'

import {
  BRANCHES_FETCH,
  BRANCH_FETCH,
  BRANCH_EMPLOYEES_FETCH,
  EMPLOYEE_BRANCH_DETACH,
  GET_COMPANY_TYPES,
  BRANCH_CREATE,
  BRANCH_UPDATE,
  BRANCH_BANK_CARD_CREATE,
  BRANCH_BANK_CARD_UPDATE,
  BRANCH_BANK_ACCOUNT_CREATE,
  BRANCH_BANK_ACCOUNT_UPDATE,
  GET_CURRENT_BRANCH_PAYMENTS
} from '../action.types'
import {
  SET_COMPANY_TYPES,
  SET_CURRENT_BRANCH,
  UPDATE_CURRENT_BRANCH_ID,
  SET_CURRENT_BRANCH_EMPLOYEES,
  DELETE_CURRENT_BRANCH_EMPLOYEE,
  SET_CURRENT_BRANCH_PAYMENTS,
  SET_COMPANY_BRANCHES,
  SET_SIDEBAR_ITEMS
} from '../mutations.types'
import router from '@/router'

export default {
  async [BRANCHES_FETCH](context) {
    await CompanyService.getBranches()
      .then(({
        data
      }) => {
        context.commit(SET_COMPANY_BRANCHES, data)
        context.commit(SET_SIDEBAR_ITEMS, data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  async [BRANCH_EMPLOYEES_FETCH](context, payload) {
    context.commit(UPDATE_CURRENT_BRANCH_ID, payload)
    await CompanyService.getBranchEmployees(payload)
      .then(({
        data
      }) => {
        context.commit(SET_CURRENT_BRANCH_EMPLOYEES, data)
      })
      .catch(error => {
        console.log(error)
        // router.push({ name: 'pageError404' })
      })
  },
  async [GET_CURRENT_BRANCH_PAYMENTS](context, payload) {
    await CompanyService.getTranscations(payload)
      .then(({
        data
      }) => {
        context.commit(SET_CURRENT_BRANCH_PAYMENTS, data)
      })
      .catch(error => {
        console.log(error)
        // router.push({ name: 'pageError404' })
      })
  },
  async [EMPLOYEE_BRANCH_DETACH](context, payload) {
    await CompanyService.detachEmployee(payload.id)
      .then(({
        data
      }) => {
        context.commit(DELETE_CURRENT_BRANCH_EMPLOYEE, payload.id)
        payload.notify({
          title: 'Успешно',
          text: `Пользователь ${payload.name || payload.id} отвязан от заведения`
        })
      })
      .catch(error => {
        console.log(error)
        // router.push({ name: 'pageError404' })
      })
  },
  async [BRANCH_CREATE](context, payload) {
    await CompanyService.createBranch(payload)
      .then(({
        data
      }) => {
        payload.notify({
          title: 'Успешно',
          text: `Вы создали новое заведение`
        })
        router.push({
          name: 'branchDetail',
          params: {
            id: data.branch_id
          }
        })
      })
      .catch(({
        response
      }) => {
        payload.notify({
          title: 'Ошибка',
          text: response.data
        })
      })
  },
  async [BRANCH_UPDATE](context, payload) {
    await CompanyService.updateBranch(payload.id, payload)
      .then(({
        data
      }) => {
        // text as data message
        payload.notify({
          title: 'Данные сохранены',
          text: 'Информация о заведении обновлена'
        })
      })
      .catch(({
        response
      }) => {

        // router.push({ name: 'pageError404' })
      })
  },
  async [BRANCH_FETCH](context, payload) {
    context.commit(UPDATE_CURRENT_BRANCH_ID, payload)
    await CompanyService.getBranch(payload)
      .then(({
        data
      }) => {
        const branchInfo = { id: payload, ...data }
        context.commit(SET_CURRENT_BRANCH, branchInfo)
      })
      .catch(error => {
        console.log(error)
        // router.push({ name: 'pageError404' })
      })
  },
  async [BRANCH_BANK_CARD_CREATE](context, payload) {
    await CompanyService.createBranchCard(payload.id, payload)
      .then(({
        data
      }) => {
        payload.notify({
          title: 'Новая карта успешно привязана',
          text: data['message']
        })
      })
      .catch(({
        response
      }) => {
        payload.notify({
          title: 'Не удалось прикрепить банковскую карту',
          text: response
        })
      })
  },
  async [BRANCH_BANK_CARD_UPDATE](context, payload) {
    await CompanyService.updateBranchCard(payload.id, payload)
      .then(({
        data
      }) => {
        payload.notify({
          title: 'Новая карта успешно привязана',
          text: data['message']
        })
      })
      .catch(({
        response
      }) => {
        payload.notify({
          title: 'Не удалось прикрепить банковскую карту',
          text: response
        })
      })
  },
  async [BRANCH_BANK_ACCOUNT_CREATE](context, payload) {
    await CompanyService.createBranchBankAccount(payload.id, payload)
      .then(({
        data
      }) => {
        payload.notify({
          title: 'Новый банковский счёт успешно привязан',
          text: data['message']
        })
      })
      .catch(({
        response
      }) => {
        payload.notify({
          title: 'Не удалось прикрепить банковский счёт',
          text: response.data.error
        })
      })
  },
  async [BRANCH_BANK_ACCOUNT_UPDATE](context, payload) {
    await CompanyService.updateBranchBankAccount(payload.id, payload)
      .then(({
        data
      }) => {
        payload.notify({
          title: 'Новый банковский счёт успешно привязан',
          text: data['message']
        })
      })
      .catch(({
        response
      }) => {
        payload.notify({
          title: 'Не удалось прикрепить банковский счёт',
          text: response.data.error
        })
      })
  },
  async [GET_COMPANY_TYPES](context) {
    await CompanyService.getCompanyTypes()
      .then(({
        data
      }) => {
        context.commit(SET_COMPANY_TYPES, data)
      })
      .catch(error => {
        console.log(error)
      })
  }
}
